import { render } from "./SocialFloat.vue?vue&type=template&id=a0bfa886&scoped=true"
import script from "./SocialFloat.vue?vue&type=script&lang=js"
export * from "./SocialFloat.vue?vue&type=script&lang=js"

import "./SocialFloat.vue?vue&type=style&index=0&id=a0bfa886&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0bfa886"]])

export default __exports__